// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"r2-z","colorTextValue":"s2-z","swatches":"t2-z","collapseLink":"u2-z","isCollapsed":"v2-z","dropdown":"w2-z","disabled":"x2-z"};